// @ is an alias to /src
import mastertime from '@/api/mastertime'

export const namespaced = true

export const state = {
  hardwares: [],
  totalHardwares: 0,
  hardwareStatus: [],
  hardwareModels: [],
}

export const mutations = {
  setHardwares(state, hardwares) {
    state.hardwares = hardwares
  },

  setTotalHardwares(state, totalHardwares) {
    state.totalHardwares = totalHardwares
  },

  setHardwareStatus(state, hardwareStatus) {
    state.hardwareStatus = hardwareStatus
  },

  setHardwareModels(state, hardwareModels) {
    state.hardwareModels = hardwareModels
  },

  addHardware(state, hardware) {
    state.hardwares.push(hardware)
  },

  editHardware(state, hardware) {
    const index = state.hardwares.findIndex(
      (element) => element.hardware_uuid === hardware.hardware_uuid
    )
    if (index !== -1) {
      state.hardwares.splice(index, 1, hardware)
    }
  },

  deleteHardware(state, hardware_uuid) {
    const index = state.hardwares.findIndex(
      (hardware) => hardware.hardware_uuid === hardware_uuid
    )
    if (index !== -1) {
      state.hardwares.splice(index, 1)
    }
  },
}

export const actions = {
  async fetchHardwares({ commit }, payload) {
    const { data } = await mastertime.fetchHardwares(payload)
    const hardwares = data.data
    const totalHardwares = data.total

    commit('setHardwares', hardwares)
    commit('setTotalHardwares', totalHardwares)
  },

  async fetchHardware(_, hardware_uuid) {
    const { data } = await mastertime.fetchHardware(hardware_uuid)
    const hardware = data

    return hardware
  },

  async fetchHardwareStatus({ commit }) {
    const { data } = await mastertime.fetchHardwareStatus()
    const hardwareStatus = data.data

    commit('setHardwareStatus', hardwareStatus)
  },

  async fetchHardwareModels({ commit }) {
    const { data } = await mastertime.fetchHardwareModels()
    const hardwareModels = data.data

    commit('setHardwareModels', hardwareModels)
  },

  async addHardware({ commit }, hardware) {
    const { data } = await mastertime.addHardware(hardware)
    const newHardware = data

    commit('addHardware', newHardware)
  },

  async editHardware({ commit }, hardware) {
    const { data } = await mastertime.editHardware(hardware)
    const hardwareUpdated = data

    commit('editHardware', hardwareUpdated)
  },

  async deleteHardware({ commit }, hardware_uuid) {
    await mastertime.deleteHardware(hardware_uuid)

    commit('deleteHardware', hardware_uuid)
  },

  async unRegisterHardware({ commit }, hardware_uuid) {
    const { data } = await mastertime.unRegisterHardware(hardware_uuid)
    const hardwareUpdated = data

    commit('editHardware', hardwareUpdated)
    return hardwareUpdated
  },

  async checkStatusHardware({ commit, dispatch }, hardware_uuid) {
    const hardware = await dispatch('fetchHardware', hardware_uuid)
    if (hardware.is_registered) {
      commit('editHardware', hardware)
      return hardware
    }
  },
}
